import { onMounted, onUnmounted, ref } from 'vue';
import { useLenis } from 'lenis/vue';

export function useScroll() {
  const scrollY = ref(0);

  // useLenis must be called in the setup context, not in a callback or nested function.
  useLenis((lenis) => {
    if (typeof window !== 'undefined' && window.innerWidth > 1024) {
      scrollY.value = lenis.animatedScroll;
    }
  });

  const handleMobileScroll = () => {
    scrollY.value = window.scrollY;
  };
  let listening = false;

  onMounted(() => {
    if (typeof window !== 'undefined' && window.innerWidth <= 1024 && !listening) {
      window.addEventListener('scroll', handleMobileScroll, { passive: true });
      listening = true;
    }
  });

  onUnmounted(() => {
    if (typeof window !== 'undefined' && listening) {
      window.removeEventListener('scroll', handleMobileScroll);
      listening = false;
    }
  });



  return {
    scrollY,
  };
}
